import theme from '../../../lib/theme';
import { HolidaysBlockProps } from './HolidaysBlock';

const { scale, layouts, media } = theme;

export default ({ columns = 3, isV2Collection = false }: HolidaysBlockProps) => ({
  container: {
    ...(isV2Collection ? layouts.column : layouts.spacedColumn('m')),
  },

  heading: {
    ...layouts.container('m'),
    ...layouts.spacedColumn('xs'),
    maxWidth: '100%!important',

    'h1': {
      fontSize: `24px!important`,
      lineHeight: '1.5em!important',
      margin: '0!important',
    },
    'h3': {
      fontSize: `16px!important`,
      lineHeight: '1.5em!important',
      margin: '0!important',
    },
  },

  holidays: {
    ...layouts.column,
    gap: scale.xs,
    alignItems: 'stretch',

    [media.s.up]: {
      ...layouts.row,

      alignItems: 'flex-start',
      flexWrap: 'wrap',
    },
  },

  holidaysContainer: {
    ...layouts.spacedColumn('s'),
    marginTop: scale.xxs,
  },

  holiday: {
    flex: `100% 0`,

    [media.s.up]: {
      flex: `calc(50% - ${scale.xs} / 2) 0`,
    },

    [media.l.up]: {
      flex:
        columns === 3
          ? `calc(33.33% - ${scale.xs} * 2 / 3) 0`
          : `calc(50% - ${scale.xs}  / 2) 0`,
    },
  },

  loading: {
    backgroundImage:
      "url('https://images.startsat60.com/frontend/loading-spinner-sas.gif')",
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    width: 50,
    height: 10,
  },
});
